import { FunctionComponent } from 'react';
import classnames from 'classnames';

import styles from './main.scss';

export type StepIndicatorColors = 'default' | 'tradePrimaryColor' | 'buyerSecondaryColor';

export type StepIndicatorProps = {
    dataTn?: string;
    totalSteps?: number;
    currentStep?: number;
    activeStepColor?: StepIndicatorColors;
    hasHeader?: boolean;
};

export const StepIndicator: FunctionComponent<StepIndicatorProps> = props => {
    const {
        dataTn,
        totalSteps = 0,
        currentStep = 0,
        activeStepColor = 'default',
        hasHeader,
    } = props;
    return totalSteps < 1 ? null : (
        <ol
            className={classnames(hasHeader ? styles.headerSteps : styles.steps)}
            data-tn={`step-indicator${dataTn ? `-${dataTn}` : ''}`}
        >
            {[...Array(totalSteps)].map((e, i) => (
                <li
                    key={i}
                    className={classnames(styles.step, {
                        [styles[activeStepColor]]: i < currentStep,
                        [styles.headerStep]: hasHeader,
                    })}
                />
            ))}
        </ol>
    );
};
